import React, { ReactElement, useCallback, useMemo } from "react";
import { ResourceTagFormProps } from "./ResourceTagForm.types";
import { FormSection, FormControl } from "src/ui/components/Forms";
import { localize } from "src/l10n";
import { TextField } from "@fluentui/react";
import ColorPicker, { ColorChangeHandler } from "src/ui/components/ColorPicker/ColorPicker";

/**
 * Renders the ResourceTagForm component.
 *
 * @param {ResourceTagFormProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function ResourceTagForm({
    model,
    onModelChange
}: ResourceTagFormProps): ReactElement | null {
    const l10n = useMemo(() => ({
        name: localize("Namn"),
        color: localize("Farg"),
    }), []);

    const onNameChanged = useCallback(
        (_: unknown, newValue?: string) => onModelChange((model) => ({
                ...model,
                name: newValue ?? "",
            })),
        [onModelChange]);

    const onColorChanged = useCallback<ColorChangeHandler>(
        (_, colorResult) => onModelChange((model) => ({
            ...model,
            color: colorResult.str,
        })), [onModelChange]);

    return (
        <div className="ResourceTagForm">
            <FormSection>
                <FormControl>
                    <TextField aria-required={true}
                               className="textField"
                               label={l10n.name}
                               name="name"
                               onChange={onNameChanged}
                               required={true}
                               value={model.name} />
                </FormControl>
            </FormSection>

            <FormSection>
                <FormControl label={l10n.color}>
                    <ColorPicker color={model.color}
                                 onChangeColor={onColorChanged} />
                </FormControl>
            </FormSection>
        </div>
    );
}

export default ResourceTagForm;

